var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, KompisElement, property } from '@inter-ikea-kompis/web-component';
import AccordionItem from '../accordion-item/AccordionItem.js';
import AccordionStyle from './AccordionStyle.js';
/**
 * @deprecated This component has been deprecated, see Kompis page for more info.
 *
 * Component that renders a list of {AccordionItem}.
 */
export default class Accordion extends KompisElement {
    /**
     * Renders the component.
     *
     * @returns Template.
     */
    render() {
        return html `
			<style>
				${AccordionStyle.getStyle()}
			</style>
			<div @keydown="${(event) => this.onKeyDown(event)}">
				<slot></slot>
			</div>
		`;
    }
    /**
     * When key down.
     *
     * @param event Keyboard event.
     */
    onKeyDown(event) {
        if (event.target.tagName.toLowerCase() === 'kompis-accordion-item') {
            const accordionItems = this.getAccordionItems();
            switch (event.key) {
                case 'ArrowDown':
                    event.preventDefault();
                    this.changeButtonFocus(+1);
                    break;
                case 'ArrowUp':
                    event.preventDefault();
                    this.changeButtonFocus(-1);
                    break;
                case 'Home':
                    // Focus the first AccordionItem
                    event.preventDefault();
                    accordionItems[0]?.focus();
                    break;
                case 'End':
                    // Focus the last AccordionItem
                    event.preventDefault();
                    accordionItems[accordionItems.length - 1]?.focus();
                    break;
            }
        }
    }
    changeButtonFocus(increment) {
        const buttons = this.getAccordionItems()
            .filter((node) => !node.disabled)
            .map((accordionItem) => accordionItem.shadowRoot.querySelector('button'));
        const focusedButton = this.findFocusedButton();
        if (buttons) {
            const index = buttons.findIndex((element) => element === focusedButton);
            buttons[(buttons.length + index + increment) % buttons.length]?.focus();
        }
    }
    getAccordionItems() {
        return Array.from(this.children).filter((child) => child instanceof AccordionItem);
    }
    /**
     * @returns The focused button within this shadow dom or null if there isn't one in focus.
     */
    findFocusedButton() {
        const rootNode = this.getRootNode();
        if (this.isShadowRoot(rootNode)) {
            return rootNode.activeElement?.shadowRoot?.querySelector('button') || null;
        }
        return null;
    }
    isShadowRoot(target) {
        return 'activeElement' in target;
    }
}
__decorate([
    property({ type: Object, required: true })
], Accordion.prototype, "theme", void 0);
//# sourceMappingURL=Accordion.js.map